(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('approvalClearAction', {
      controller: Controller,
      templateUrl: 'actions/approval/clear/clear-approval.action.html',
      bindings: {
        then: '&',
        catch: '&'
      }
    });
}());
